export const data=[
    {
      id:1,
      question:"Rolex is company that specializes in what type of product?",
      answers:[
        {
          text:"Phone",
          correct:false
        },
        {
          text:"Watches",
          correct:true
        },
        {
          text:"Food",
          correct:false
        },
        {
          text:"Car",
          correct:false
        },
      ]
    },
    
    {
      id: 2,
      question: "When did the website `Facebook` launch?",
      answers: [
        {
          text: "2004",
          correct: true,
        },
        {
          text: "2005",
          correct: false,
        },
        {
          text: "2006",
          correct: false,
        },
        {
          text: "2007",
          correct: false,
        },
      ],
    },
    {
      id: 3,
      question: "Who played the character of harry potter in movie?",
      answers: [
        {
          text: "Johnny Deep",
          correct: false,
        },
        {
          text: "Leonardo Di Caprio",
          correct: false,
        },
        {
          text: "Denzel Washington",
          correct: false,
        },
        {
          text: "Daniel Red Cliff",
          correct: true,
        },
      ],
    },
    {
      id: 4,
      question: "'OS' computer abbreviation usually means ?",
      answers: [
        {
          text: "Open Software",
          correct: false,
        },
        {
          text: "Order of Significance",
          correct: false,
        },
        {
          text: "Operating System",
          correct: true,
        },
        {
          text: "Optical Sensor",
          correct: false,
        },
      ],
    },
    {
      id: 5,
      question: "What's a web browser",
      answers: [
        {
          text: "A kind of spider",
          correct: false,
        },
        {
          text: "A computer that stores WWW files",
          correct: false,
        },
        {
          text: "A person who likes to look at websites",
          correct: false,
        },
        {
          text: "A software program that allows you to access sites on the World Wide Web",
          correct: true,
        },
      ],
    },
    {
      id: 6,
      question: "http://www.indiabix.com - is an example of what?",
      answers: [
        {
          text: "A URL",
          correct: true,
        },
        {
          text: "An access code",
          correct: false,
        },
        {
          text: "A directory",
          correct: false,
        },
        {
          text: "A server",
          correct: false,
        },
      ],
    },
    {
      id: 7,
      question: "How many bits is a byte?",
      answers: [
        {
          text: "8",
          correct: true,
        },
        {
          text: "4",
          correct: false,
        },
        {
          text: "16",
          correct: false,
        },
        {
          text: "32",
          correct: false,
        },
      ],
    },
    {
      id: 8,
      question: "Computers calculate numbers in what mode?",
      answers: [
        {
          text: "Decimal",
          correct: false,
        },
        {
          text: "Octal",
          correct: false,
        },
        {
          text: "Binary",
          correct: true,
        },
        {
          text: "None of these",
          correct: false,
        },
      ],
    },
    {
      id: 9,
      question: "The speed of your net access is defined in terms of...",
      answers: [
        {
          text: "Kbps",
          correct: true,
        },
        {
          text: "MHz",
          correct: false,
        },
        {
          text: "Megabytes",
          correct: false,
        },
        {
          text: "RAM",
          correct: false,
        },
      ],
    },
    {
      id: 10,
      question: "Which of these is a search engine?",
      answers: [
        {
          text: "FTP",
          correct: false,
        },
        {
          text: "Archie",
          correct: false,
        },
        {
          text: "ARPANET",
          correct: false,
        },
        {
          text: "Google",
          correct: true,
        },
      ],
    },
    {
      id: 11,
      question: "Which of the following is the correct name of React.js?",
      answers: [
        {
          text: "React",
          correct: false,
        },
        {
          text: "React.js",
          correct: false,
        },
        {
          text: "ReactJS",
          correct: false,
        },
        {
          text: "All the above",
          correct: true,
        },
      ],
    },
    {
      id: 12,
      question: "Which of the following command is used to install create-react-app?",
      answers: [
        {
          text: "npm install -g create-react-app",
          correct: false,
        },
        {
          text: "npm install create-react-app",
          correct: true,
        },
        {
          text: "npm install -f create-react-app",
          correct: false,
        },
        {
          text: "install -g create-react-app",
          correct:false,
        },
      ],
    },
    {
      id: 13,
      question: "What of the following is used in React.js to increase performance?",
      answers: [
        {
          text: "Virtual Dom",
          correct: true,
        },
        {
          text: "Original Dom",
          correct: false,
        },
        {
          text: "Both A and B.",
          correct: false,
        },
        {
          text: "None of these",
          correct:false,
        },
      ],
    },
    {
        id: 14,
        question: "What is part of a database that holds only one type of information?",
        answers: [
          {
            text: "Report",
            correct: false,
          },
          {
            text: "Feild",
            correct: true,
          },
          {
            text: "Rrcord",
            correct: false,
          },
          {
            text: "File",
            correct: false,
          },
        ],
      },
      {
        id: 15,
        question: "What is the default port where webpack-server runs?",
        answers: [
          {
            text: "3000",
            correct: false,
          },
          {
            text: "3030",
            correct: true,
          },
          {
            text: "8080",
            correct: true,
          },
          {
            text: "6060",
            correct: false,
          },
        ],
      },
    
    
  ]